/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const globalStyles = (theme: Theme) => ({
  html: {
    height: "100%",
    scrollPaddingTop: "4rem",
    [theme.breakpoints.up("md")]: {
      scrollPaddingTop: "5rem",
    },
  },
  body: {
    height: "100%",
  },
  "#root": {
    height: "100%",
  },
  a: {
    color: theme.palette.primary.main,
    textDecoration: "none",
  },
});

export default globalStyles;
